import clsx from 'clsx';
import styles from './Card.module.css';

export function Card({ as = 'section', className = '', children, ...rest }) {
  const Tag = as;
  return (
    <Tag className={clsx(styles.card, className)} {...rest}>
      {children}
    </Tag>
  );
}
